import React from 'react';
import Classes from './RecordTable.module.css';
import { useNavigate } from 'react-router-dom';
import MoreDropDown from './MoreDropDown';
import DropDown from './StatusDropDown/DropDown';

export default function TableRow({ value, index, onRemoved }) {
  const navigateTo = useNavigate();
  const refunded = Number(value?.RefundedRaw || 0) > 0;

  const RefundPill = refunded ? (
    <span
      // style={{
      //   marginLeft: 8,
      //   padding: '2px 8px',
      //   borderRadius: 999,
      //   background: 'rgba(99,102,241,0.12)',
      //   border: '1px solid rgba(99,102,241,0.35)',
      //   color: '#6366F1',
      //   fontSize: 12,
      //   fontWeight: 600,
      //   whiteSpace: 'nowrap',
      // }}
      // title="Refund applied"
    >
      {/* {value?.RefundedLabel || 'Refunded'} */}
    </span>
  ) : null;

  const TotalCell = (
    <div className={`${Classes.rowElem} ${Classes.elem4}`}>
      <h5>{value.Total}</h5>
      {refunded && (
        <div style={{ marginTop: 2, fontSize: 11, color: '#6b7280' }}>
          {/* Refund Applied */}
        </div>
      )}
    </div>
  );

  return (
    <>
      <div className={Classes.customerRow} key={value._id}>
        <div className={`${Classes.rowElem} ${Classes.elem1}`}><h5>{value.Number}</h5></div>

        <div className={`${Classes.rowElem} ${Classes.elem3}`} style={{ display: 'flex', alignItems: 'center' }}>
          <DropDown selectedValue={value.Status} isDropDown={false} />
          {RefundPill}
        </div>

        {TotalCell}

        <div className={`${Classes.rowElem} ${Classes.elem5}`}><h5>{value.Created}</h5></div>
        <div className={`${Classes.rowElem} ${Classes.elem6}`}><h5>{value.Paid}</h5></div>
        <div className={`${Classes.rowElem} ${Classes.elem7}`}>
          <MoreDropDown
            invoiceId={value._id}
            onView={() => navigateTo(`/view-invoice/${value._id}`)}
            onRemoved={() => onRemoved?.(value._id)}
          />
        </div>
      </div>

      {/* Mobile layout */}
      <div className={Classes.customerRowMobile}>
        <div>
          <div className={Classes.mobElem}><h4>Number</h4><h5>{value.Number}</h5></div>
          <div className={Classes.mobElem} style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            <h4>Status</h4>
            <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
              <DropDown selectedValue={value.Status} isDropDown={false} />
              {RefundPill}
            </div>
          </div>
        </div>

        <div>
          <div className={Classes.mobElem}>
            <h4>Total</h4>
            <div>
              <h5>{value.Total}</h5>
              {refunded && (
                <div style={{ marginTop: 2, fontSize: 11, color: '#6b7280' }}>
                  Total shown after refunds
                </div>
              )}
            </div>
          </div>
          <div className={Classes.mobElem}><h4>Created</h4><h5>{value.Created}</h5></div>
          <div className={Classes.mobElem}><h4>Paid</h4><h5>{value.Paid}</h5></div>
        </div>

        <MoreDropDown
          invoiceId={value._id}
          onView={() => navigateTo(`/view-invoice/${value._id}`)}
          onRemoved={() => onRemoved?.(value._id)}
        />
      </div>
    </>
  );
}
